import { amplifyPasswordExceptionCodes } from '../constants/amplify-api-constants'
import { businessMessages } from '../constants/business-message-constants'

/* AWS does not return unique exception code for each password rule, 
   and therefore must observe the aws exception message to return
   customized business exception message for our users.
*/
function getInvalidNewPasswordExceptionMessage(exception) {
  let message
  if (exception.includes('Password not long enough')) {
    message = businessMessages.password.NEW_PASSWORD_LENGTH_EXCEPTION
  } else if (exception.includes('Password must have numeric characters')) {
    message = businessMessages.password.NEW_PASSWORD_NUMBER_EXCEPTION
  } else if (exception.includes('Password must have lowercase characters')) {
    message = businessMessages.password.NEW_PASSWORD_LOWERCASE_EXCEPTION
  } else if (exception.includes('Password must have uppercase characters')) {
    message = businessMessages.password.NEW_PASSWORD_UPPERCASE_EXCEPTION
  } else if (exception.includes('Password must have symbol characters')) {
    message = businessMessages.password.NEW_PASSWORD_SYMBOL_EXCEPTION
  } else {
    message = exception
  }
  return message
}

/* Returns custom business exception message based on the exception code
   thrown by AWS Cognito's Forgot and Change Password APIs.
*/
function getAmplifyPasswordExceptionMessage(exception) {
  switch (exception.name) {
    case amplifyPasswordExceptionCodes.password.EXPIRED_CODE_EXCEPTION:
      return businessMessages.password.TEMPORARY_PASSWORD
    case amplifyPasswordExceptionCodes.password.LIMIT_EXCEEDED_EXCEPTION:
      return exception.message
    case amplifyPasswordExceptionCodes.password.USER_NOT_FOUND_EXCEPTION:
      return businessMessages.password.USER_NAME_DOES_NOT_EXIST
    case amplifyPasswordExceptionCodes.password.INVALID_PASSWORD_EXCEPTION:
      return getInvalidNewPasswordExceptionMessage(exception.message)
    case amplifyPasswordExceptionCodes.password.NOT_AUTHORIZED_EXCEPTION:
      return exception.message
    default:
      return exception.message
  }
}

function transformAuthenticatedUserData(response) {
  /* Transformed object for users authenticated through
     user microservice */
  return {
    username: response.username,
    clientCode: response?.clientCode,
    clientName: response?.clientName,
    dms: response?.dmsFlag,
    dmsdb: response?.dmsDB,
    firstName: response?.firstName,
    lastName: response?.lastName,
    invitedBy: response?.invitedBy,
    userType: response?.userType,
    whse_code: response?.warehouseCode,
    wmsdb: response?.wmsdb,
    website: response?.websiteUrl,
    appName: response.appName,
    email: response.email,
    roles: response.roles,
    permissions: response.permissions,
  }
}

function transformCognitoUserData(cognitoUserData) {
  /* Transformed object for users authenticated through
     amplify library */
  const attributes = cognitoUserData?.attributes
  return (
    attributes && {
      clientCode: attributes['custom:client'],
      clientName: attributes['custom:clientName'],
      dms: attributes['custom:dms'],
      dmsdb: attributes['custom:dmsdb'],
      firstName: attributes['custom:firstName'],
      invitedBy: attributes['custom:invitedBy'],
      lastName: attributes['custom:lastName'],
      userType: attributes['custom:userType'],
      whse_code: attributes['custom:whse_code'],
      wmsdb: attributes['custom:wmsdb'],
      email: attributes?.email,
      website: attributes?.website,
      profile: attributes?.profile,
    }
  )
}
export {
  getAmplifyPasswordExceptionMessage,
  transformCognitoUserData,
  transformAuthenticatedUserData,
}
